import { render } from "./ParameterDelete.vue?vue&type=template&id=d40c037c"
import script from "./ParameterDelete.vue?vue&type=script&lang=js"
export * from "./ParameterDelete.vue?vue&type=script&lang=js"

import exportComponent from "C:\\devPrivate\\cmsDubaiMailing\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__